import { Colors } from "../../../../styles/theme";

const styles = {
   Promotion_container: {
    background: Colors.primary,
    margin: 0,
    padding: "16px 20px",
  },
}
export default styles;
